// @ts-nocheck
import React, { useState, useEffect } from "react";
import "../../styles/certificates.css";
import { certificatesItemsFunction } from "js/certificatesBackend";
import { PICS_URL } from "api";
import Seo from 'components/Seo';
import { useStores } from "hooks/useStores";

const CertificatesPage = () => {
  const [certificates, setCertificates] = useState([]);
  const [mainItems, setMainItems] = useState({});
  const { api } = useStores();

  useEffect(() => {
    api.content.getPageApi('certificates')
    .then((response) => {
      if (response.init_state) {
        setMainItems(response.init_state.object);
        setCertificates(response.init_state.certificates);
      }
    })
  }, [])

  useEffect(() => {
    if (certificates.length) {
      certificatesItemsFunction(certificates);
    }
  }, [certificates]);

  const certJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": mainItems?.seo_title || "Сертификаты",
    "description": mainItems?.seo_description || "Сертификаты качества компании Пак Пакыч",
    "url": window.location.href
  };

  return (
    <>
      <Seo seo={mainItems} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(certJsonLd) }}
      />
      <main id='certificatesPage'>
        <section className='certificates'>
          <div className='certificates-wrap'>
            <div className='certificates-title'>Сертификаты</div>
            <div className='certificates-cards'>
              {certificates.map((certificate) => (
                <div key={certificate.id} className='certificates-cards__item'>
                  <div className='certificates-cards__item-inner'>
                    <div className='certificates-cards__item-title'>
                      {certificate.title}
                    </div>
                    <div className='certificates-cards__item-descr'>
                      {certificate.description}
                    </div>
                    <div className='certificates-cards__item-btn'>
                      <div className='certificates-cards__item-btn-arrow'></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <div className='modal-windows-js'>
          {certificates.map((cert) => (
            <div className='cert-modal-bg'>
              <iframe
                className='cert-modal-content'
                title='PDF in an i-Frame'
                src={PICS_URL + cert.file}
              ></iframe>
              <div className='cert-modal-close'></div>
            </div>
          ))}
        </div>
      </main>
    </>
  );
};

export default CertificatesPage;
